import { render, staticRenderFns } from "./modal-menu.vue?vue&type=template&id=475415cc&"
import script from "./modal-menu.vue?vue&type=script&lang=js&"
export * from "./modal-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports